import { ReactElement } from 'react'

import EditUsuario from 'modules/user/pages/EditUsuario'
import SignInImpl from 'modules/auth/domain/usecases/SignInImpl'
import AuthRepository from 'modules/auth/infra/repositories/AuthRepository'
import UserRepository from 'modules/user/infra/repositories/UserRepository'
import UpdateUsuarioImpl from 'modules/user/domain/usecases/UpdateUsuarioImpl'

export const EditUsuarioFactory = (): ReactElement => {
  const authRepository = new AuthRepository()
  const userRepository = new UserRepository()
  const signInImpl = new SignInImpl(authRepository)
  const updateUserImpl = new UpdateUsuarioImpl(userRepository)

  return <EditUsuario signIn={signInImpl} updateUser={updateUserImpl} />
}
